import { useMediaQuery } from '@vueuse/core'

const isReduced = useMediaQuery('(prefers-reduced-motion: reduce)')

export const useGlobalReducedMotion = () => isReduced
